import { Col, Select } from "antd";

import { IDocumentTypeField } from "./IDocumentTypeField";

const { Option } = Select;

const DocumentTypeField = ({
	value,
	index,
	translations,
	errors,
	handleSelect,
	disabled = false,
}: IDocumentTypeField) => (
	<Col xs={24} md={6} lg={6} className="titles">
		<label className="required"> {translations.documentType} </label>
		<Select
			className="input-field"
			value={value}
			disabled={disabled}
			onChange={handleSelect("documentType", index || 0)}
			status={errors[index].documentType ? 'error' : ''}
			placeholder={translations.seleccioneOpcion}
		>
			<Option value="dni">{translations.dni}</Option>
			<Option value="nif">{translations.nif}</Option>
			<Option value="passport">{translations.passport}</Option>

		</Select>
		<span className={`error ${errors[index].documentType ? 'show' : null}`}>{translations.seleccioneOpcion}</span>
	</Col>
);

export default DocumentTypeField;
